<template>
     <CNavGroup>
        <template #togglerContent>
          <CIcon  customClassName="nav-icon" icon="cil-cursor"/> {{navDetails.template_name}}
        </template>
        <CNavItem  v-for="(item,index) in navDetails.nav_items" :key="index" :href=item.url>
           {{item.name}}
        </CNavItem>
      </CNavGroup>
</template>
   
<script>
import { ref } from 'vue'
export default {
    name: 'sideBarNav',
    props: ['role','inner_role'],
    setup (props) {
        var navDetails = ref({});
        navDetails.value.nav_items = [];
        if(props.role == "lms"){
            navDetails.value.template_name = 'LMS'
            navDetails.value.nav_items.push({ "name" : "Courses", "url": "#/lms/courses"})
            navDetails.value.nav_items.push({ "name" : "Microdegree", "url": "#/lms/microdegree"})
        }else if(props.role == "lms_analytics"){
            navDetails.value.template_name = 'LMS Analytics'
            navDetails.value.nav_items.push({ "name" : "Session Schedule", "url": "#/lms-analytics/session/schedule"})
            navDetails.value.nav_items.push({ "name" : "Session Attendance", "url": "#/lms-analytics/session/attendance"})
            navDetails.value.nav_items.push({ "name" : "Session Reschedule", "url": "#/lms-analytics/session/reschedule"})
            navDetails.value.nav_items.push({ "name" : "Session Pending feedback", "url": "#/lms-analytics/session/pending/feedback"})
            navDetails.value.nav_items.push({ "name" : "Lms feedback", "url": "#/lms/feedback"})
            navDetails.value.nav_items.push({ "name" : "Lms Session Completion Feedback", "url": "#/lms/session/completion/feedback"})
            navDetails.value.nav_items.push({ "name" : "Users Submission Detail", "url": "#/lms/user/submission"})
            navDetails.value.nav_items.push({ "name" : "LMS Usage Stats", "url": "#/lms-analytics/usage/stats"})
            navDetails.value.nav_items.push({ "name" : "Course Ending", "url": "#/lms-analytics/course/ending"})
        }else if(props.role == "app_product"){
            navDetails.value.template_name = 'App Product Data'
            navDetails.value.nav_items.push({ "name" : "Products", "url": "#/app-product-data"})
        }else if(props.role == "product"){
            navDetails.value.template_name = 'Products'
            if(props.inner_role == 'registration'){
                navDetails.value.nav_items.push({ "name" : "Product Registration", "url": "#/products/registration"})
            }else{
                navDetails.value.nav_items.push({ "name" : "Product Listing", "url": "#/products/listing"})
                navDetails.value.nav_items.push({ "name" : "Accessory Listing", "url": "#/accessories/listing"})
                navDetails.value.nav_items.push({ "name" : "Shop Details", "url": "#/products/shop"})
                navDetails.value.nav_items.push({ "name" : "Shop Filter", "url": "#/products/filter"})
            }
        }else if(props.role == "curriculum"){
            navDetails.value.template_name = "Curriculum"
            navDetails.value.nav_items.push({ "name" : "Category", "url": "#/curriculum/category/listing"})
            navDetails.value.nav_items.push({ "name" : "Quiz", "url": "#/curriculum/quiz/listing"})
            navDetails.value.nav_items.push({ "name" : "Generic Checkpoint", "url": "#/curriculum/generic/checkpoint/listing"})
            navDetails.value.nav_items.push({ "name": "SKU catalog", "url": "#/curriculum/sku/catalog" })
            navDetails.value.nav_items.push({ "name": "Downloads", "url": "#/curriculum/downloads" })
        }else if(props.role == "production"){
            navDetails.value.template_name = "Production"
            navDetails.value.nav_items.push({ "name" : "Bulk Qr", "url": "#/production/bulk/qr"})
            navDetails.value.nav_items.push({ "name" : "Marketing Qr", "url": "#/production/marketing/qr"})
            navDetails.value.nav_items.push({ "name" : "Brain Testing", "url": "#/production/brain/testing"})
            navDetails.value.nav_items.push({ "name" : "BLE Testing", "url": "#/production/ble/testing"})
            navDetails.value.nav_items.push({ "name" : "Return Brain Testing", "url": "#/production/return/brain/testing"})
            navDetails.value.nav_items.push({ "name" : "Sensor Testing", "url": "#/production/sensor/testing"})
            navDetails.value.nav_items.push({ "name" : "Brain Qr Download", "url": "#/production/brain/qr/download"})
            navDetails.value.nav_items.push({ "name" : "Make Finished Stock", "url": "#/production/make/finished/stock"})
            navDetails.value.nav_items.push({ "name" : "Finished Stock Listing", "url": "#/production/finished/stock/listing"})
            navDetails.value.nav_items.push({ "name" : "Make Semi Finished Stock", "url": "#/production/make/semi-finished/stock"})
            navDetails.value.nav_items.push({ "name" : "Semi Finished Stock Listing", "url": "#/production/semi-finished/stock/listing"})
            navDetails.value.nav_items.push({ "name" : "Make Wip2", "url": "#/production/make/wip2"})
            navDetails.value.nav_items.push({ "name" : "Make Wip2 Free", "url": "#/production/make/wip2/free"})
            navDetails.value.nav_items.push({ "name" : "Wip2 Listing", "url": "#/production/wip2/stock/listing"})
            navDetails.value.nav_items.push({ "name" : "Return Kit", "url": "#/production/return/kit"})
            navDetails.value.nav_items.push({ "name" : "Return Semi Finished", "url": "#/production/return/semi-finished"})
            navDetails.value.nav_items.push({ "name" : "BOM Sequencee", "url": "#/production/bom/sequence"})
        }else if(props.role == "raw_material"){
            navDetails.value.template_name = "Raw Material"
            navDetails.value.nav_items.push({ "name" : "Material Components", "url": "#/raw-material/component"})
           // if(!props.inner_role){
                navDetails.value.nav_items.push({ "name" : "Material Types", "url": "#/raw-material/type"})
               // navDetails.value.nav_items.push({ "name" : "Add Component Quantity", "url": "#/raw-material/update-material-quantity"})
                navDetails.value.nav_items.push({ "name" : "WIP1 Bom", "url": "#/raw-material/wip1-bom"})
                navDetails.value.nav_items.push({ "name" : "WIP2 Bom", "url": "#/raw-material/wip2-bom"})
                navDetails.value.nav_items.push({ "name" : "SF Goods", "url": "#/raw-material/semi-finished-bom"})
                navDetails.value.nav_items.push({ "name" : "Finished Goods", "url": "#/raw-material/finished-bom"})
                navDetails.value.nav_items.push({ "name" : "DPV", "url": "#/raw-material/dpv/listing"})
                navDetails.value.nav_items.push({ "name" : "Dispute", "url": "#/raw-material/dispute/listing"})
               
            //}
        }else if(props.role == "raw_material_planning_view"){
            navDetails.value.template_name = "Planning & View"
            navDetails.value.nav_items.push({ "name" : "Minimum Stock View", "url": "#/raw-material/minimum/stock/view"})
            navDetails.value.nav_items.push({ "name" : "Critical Stock View", "url": "#/raw-material/critical/stock/view"})
            navDetails.value.nav_items.push({ "name" : "Material Weekly View", "url": "#/raw-material/material/weekly/view"})
            navDetails.value.nav_items.push({ "name" : "Challan View", "url": "#/raw-material/material/issue/view"})
            navDetails.value.nav_items.push({ "name" : "Purchase Planning", "url": "#/raw-material/required/quantity"})
            navDetails.value.nav_items.push({ "name" : "Vendor Ledger", "url": "#/raw-material/vendor/invoices"})
            navDetails.value.nav_items.push({ "name" : "Price Calculation", "url": "#/raw-material/price/calculation"})
            navDetails.value.nav_items.push({ "name" : "Dead Stock", "url": "#/raw-material/dead/stock"})
            navDetails.value.nav_items.push({ "name" : "Stock Movement", "url": "#/raw-material/stock/movement"})
            navDetails.value.nav_items.push({ "name" : "Component Ageing Analysis", "url": "#/raw-material/aging/analysis"})
            navDetails.value.nav_items.push({ "name" : "Opening Stock View", "url": "#/raw-material/opening/stock/view"})
            navDetails.value.nav_items.push({ "name" : "BOM Price Analysis", "url": "#/raw-material/bom/price/analysis"})
            navDetails.value.nav_items.push({ "name" : "Wip1 Ageing", "url": "#/stock/aging/listing/wip1"})
            navDetails.value.nav_items.push({ "name" : "Wip2 Ageing", "url": "#/stock/aging/listing/wip2"})
            navDetails.value.nav_items.push({ "name" : "Semi Finished Ageing", "url": "#/stock/aging/listing/semi_finished"})
            navDetails.value.nav_items.push({ "name" : "Finished Ageing", "url": "#/stock/aging/listing/finished"})
            navDetails.value.nav_items.push({ "name" : "Stock Ageing", "url": "#/raw-material/stock/ageing"})
        }else if(props.role == "vendor"){
            navDetails.value.template_name = "Vendor"
            if(props.inner_role == 'purchase' || !props.inner_role){
                navDetails.value.nav_items.push({ "name" : "Vendors", "url": "#/raw-material/vendor"})
            }
            if(props.inner_role == 'finance' || !props.inner_role){
                navDetails.value.nav_items.push({ "name" : "New Vendor Invoices", "url": "#/raw-material/new/vendor/invoices"})
            }
        }else if(props.role == "projects"){
            navDetails.value.template_name = "Projects"
            navDetails.value.nav_items.push({ "name" : "Analytics", "url": "#/projects/analytics"})
            navDetails.value.nav_items.push({ "name" : "Pending Projects", "url": "#/projects/pending"})
            navDetails.value.nav_items.push({ "name" : "Approved Projects", "url": "#/projects/approved"})
            navDetails.value.nav_items.push({ "name" : "Disapproved Projects", "url": "#/projects/disapproved"})
            navDetails.value.nav_items.push({ "name" : "Projects Videos", "url": "#/projects/videos"})
        }else if(props.role == "event"){
            navDetails.value.template_name = 'Events'
            if(props.inner_role == 'registration'){
                navDetails.value.nav_items.push({ "name" : "Team Operations", "url": "#/events/team-operations"})
                navDetails.value.nav_items.push({ "name" : "Registration Desk", "url": "#/events/registrar"})
            }else if(props.inner_role == 'testing'){
                navDetails.value.nav_items.push({ "name" : "Judges Panel", "url": "#/events/judges"})
            }else{    
                navDetails.value.nav_items.push({ "name" : "Create Event", "url": "#/events/create"})
                navDetails.value.nav_items.push({ "name" : "Task Templates", "url": "#/events/task-system/templates"})
                navDetails.value.nav_items.push({ "name" : "Event Task Composer", "url": "#/events/task-system/composer"})
                navDetails.value.nav_items.push({ "name" : "Task Progress", "url": "#/events/task-system/progress"})
                navDetails.value.nav_items.push({ "name" : "Event Listing", "url": "#/events/listing"})
                navDetails.value.nav_items.push({ "name" : "Registrations", "url": "#/events/registrations"})
                navDetails.value.nav_items.push({ "name" : "Arena Sheet Print (Beta)", "url": "#/events/league-sheet"})
                navDetails.value.nav_items.push({ "name" : "Arena Sheet Scan (Beta)", "url": "#/events/league-scan"})
                navDetails.value.nav_items.push({ "name" : "Team Operations", "url": "#/events/team-operations"})
                navDetails.value.nav_items.push({ "name" : "Zonals", "url": "#/events/zonals"})
                navDetails.value.nav_items.push({ "name" : "Registration Desk", "url": "#/events/registrar"})
                navDetails.value.nav_items.push({ "name" : "Verification", "url": "#/events/verifier"})
                navDetails.value.nav_items.push({ "name" : "Track Team", "url": "#/events/advanced-registrations"})
            }
        }else if(props.role == "partner_admin"){
            navDetails.value.template_name = "Partner"
            navDetails.value.nav_items.push({ "name" : "Partner Listing", "url": "#/partner/listing"})
        }else if(props.role == "notification_admin"){
            navDetails.value.template_name = "Notifications"
            navDetails.value.nav_items.push({ "name" : "Create Notification", "url": "#/notifications/create"})
            navDetails.value.nav_items.push({ "name" : "Listing Notification", "url": "#/notifications/listing"})
            navDetails.value.nav_items.push({ "name" : "Template Listing", "url": "#/notifications/template/listing"})
        }else if(props.role == "order_form"){
            navDetails.value.template_name = "Order Form"
            if(props.inner_role == 'sales'){
                navDetails.value.nav_items.push({ "name" : "Order Place", "url": "#/orders/place"})
                navDetails.value.nav_items.push({ "name" : "My Orders", "url": "#/orders/my/listing"})
            }
            navDetails.value.nav_items.push({ "name" : "Order Filter", "url": "#/orders/filter"})
            navDetails.value.nav_items.push({ "name" : "Order Listing", "url": "#/orders/listing"})
            navDetails.value.nav_items.push({ "name" : "Order Report", "url": "#/orders/report"})
            navDetails.value.nav_items.push({ "name" : "Order Combine Report", "url": "#/orders/combine/report"})
        }else if(props.role == "blogs"){
            navDetails.value.template_name = "Blogs"
            navDetails.value.nav_items.push({ "name" : "Blog Listing", "url": "#/blogs/listing"})
            navDetails.value.nav_items.push({ "name" : "Create Blog", "url": "#/blogs/create"})
        }else if(props.role == "inside_sales"){
            navDetails.value.template_name = "Inside Sales"
            navDetails.value.nav_items.push({ "name" : "Inside Sales Listing", "url": "#/purchase/listing"})
            navDetails.value.nav_items.push({ "name" : "Create URL", "url": "#/purchase/create/url"})
        }else if(props.role == "license_admin"){
            navDetails.value.template_name = "Licenses"
            navDetails.value.nav_items.push({ "name" : "B2B License Listing", "url": "#/license/b2b/listing"})
            navDetails.value.nav_items.push({ "name" : "User License Listing", "url": "#/license/user/listing"})
        }else if(props.role == "sku"){
            navDetails.value.template_name = "Avishkaar SKU"
            navDetails.value.nav_items.push({ "name" : "SKU Listing", "url": "#/sku/listing"})
            navDetails.value.nav_items.push({ "name" : "Add SKU", "url": "#/sku/add/product"})
        }else if(props.role == "pipeline"){
            navDetails.value.template_name = "Avishkaar Release"
            navDetails.value.nav_items.push({ "name" : "Shop Release", "url": "#/release/shop"})
        }else if(props.role == "course"){
            navDetails.value.template_name = "Courses"
            navDetails.value.nav_items.push({ "name" : "Course Listing", "url": "#/course/listing"})
            navDetails.value.nav_items.push({ "name" : "Course Shop Details", "url": "#/course/shop"})
        }else if(props.role == "inventory"){
            navDetails.value.template_name = "Inventory"
            if(props.inner_role == 'production'){
                navDetails.value.nav_items.push({ "name" : "Place Order", "url": "#/inventory/place/order"})
            }
            if(props.inner_role == 'store'){
                navDetails.value.nav_items.push({ "name" : "Add Stock", "url": "#/inventory/add/stock"})
            }
            navDetails.value.nav_items.push({ "name" : "Order Listing", "url": "#/inventory/order/listing"})
            navDetails.value.nav_items.push({ "name" : "Stock", "url": "#/inventory/stock"})
            navDetails.value.nav_items.push({ "name" : "Inventory Cost", "url": "#/inventory/cost"})
            // navDetails.value.nav_items.push({ "name" : "Component for Internal Purpose", "url": "#/inventory/internal/component"})
            navDetails.value.nav_items.push({ "name" : "Rejected Materials", "url": "#/inventory/rejected/orders"})
            navDetails.value.nav_items.push({ "name" : "Partial Orders", "url": "#/inventory/partial/orders"})
            navDetails.value.nav_items.push({ "name" : "Wip1 Rejection", "url": "#/inventory/wip1/rejection"})
        }else if(props.role == "ams_play"){
            navDetails.value.template_name = "AMS Play"
            navDetails.value.nav_items.push({ "name" : "AMS Play Types", "url": "#/ams-play/types"})
        }else if(props.role == "community_dashboard"){
            navDetails.value.template_name = "Community"
            navDetails.value.nav_items.push({ "name" : "Dashboard", "url": "#/community/dashboard"})
            navDetails.value.nav_items.push({ "name" : "User Lookup", "url": "#/community/user/lookup"})
            navDetails.value.nav_items.push({ "name" : "Registration Code Extractor", "url": "#/community/registration/code"})
            navDetails.value.nav_items.push({ "name" : "Product Registration", "url": "#/community/product/registration"})
            navDetails.value.nav_items.push({ "name" : "Teacher Nomination", "url": "#/community/teacher/nomination/listing"})
        }else if(props.role == 'service_request'){
            navDetails.value.template_name = "Service Request"
            navDetails.value.nav_items.push({ "name" : "Request Listing", "url": "#/service/request/listing"})
        }else if(props.role == "avishkaar_popup"){
            navDetails.value.template_name = "Avishkaar Pop-ups"
            navDetails.value.nav_items.push({ "name" : "Pop-ups Listing", "url": "#/popup/listing"})
            navDetails.value.nav_items.push({ "name" : "Create Pop-ups", "url": "#/popup/create"})
        }else if(props.role == "discount_coupon"){
            navDetails.value.template_name = "Discount Coupon"
            navDetails.value.nav_items.push({ "name" : "Coupon Listing", "url": "#/discount/coupon/listing"})
            navDetails.value.nav_items.push({ "name" : "Create Coupon", "url": "#/discount/create/coupon"})
        }else if(props.role == "ims_po"){
            navDetails.value.template_name = "IMS PO"
            navDetails.value.nav_items.push({ "name" : "PO Listing", "url": "#/ims/po/listing"})
        }else if(props.role == "receipt_note"){
            navDetails.value.template_name = "Receipt Note"
            navDetails.value.nav_items.push({ "name" : "RN Listing", "url": "#/receipt/note/listing"})
        }else if(props.role == "internal_issue"){
            navDetails.value.template_name = "Internal Issue"
            navDetails.value.nav_items.push({ "name" : "Issue Listing", "url": "#/internal/issue/listing"})
        }else if(props.role == "admin_logs"){
            navDetails.value.template_name = "Admin Logs"
            navDetails.value.nav_items.push({ "name" : "Logs", "url": "#/admin/activity/logs"})
        }else if(props.role == "physical_event"){
            navDetails.value.template_name = "Physical Event"
            navDetails.value.nav_items.push({ "name" : "Listing", "url": "#/physical/event/listing"})
        }else if(props.role == "home"){
            navDetails.value.template_name = "Home"
            navDetails.value.nav_items.push({ "name" : "Home Details", "url": "#/home/details"})
            navDetails.value.nav_items.push({ "name" : "Regulatory Page", "url": "#/home/regulatory/page"})
        }else if(props.role == "material_request"){
            navDetails.value.template_name = "Material Issue"
            navDetails.value.nav_items.push({ "name" : "Issue Listing", "url": "#/material/issue/listing"})
        }else if(props.role == "admin_management"){
            navDetails.value.template_name = "Admin Management"
            navDetails.value.nav_items.push({ "name" : "Manage Admins", "url": "#/admin/management/manage"})
        }
        return { navDetails}
    } 
}
</script>
   